import { IMarkKhongDuDieuKienHocTapXetTotNghiepViewModel } from "../../../model/response/xet-tot-nghiep/IMarkKhongDuDieuKienHocTapXetTotNghiepViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: [] as IMarkKhongDuDieuKienHocTapXetTotNghiepViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",
}

export const eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionIds = generateActionTypeIds(eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP");
export type IKhongDuDieuKienKetQuaHocTapXetTotNghiepActionTypes = IGenericActionType<typeof eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP">;